import React, { useEffect, useState } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { userUuidSelector, withBamLayoutSelector } from '@redux/user/selectors';
import { useSelector } from 'react-redux';

import Loader from 'components/shared/Loader';
import { COLOR_THEME } from 'constants/colorThemes';
import { useTvToIpadMultiScreenEventsListener } from 'services/hooks/useMultiScreenEventListener';
import { PlayerEvent } from 'shared-types/player-event';

import { LayoutContainer, StyledTslLogo, ChildrenContainer, AdminLogoBAM } from './AdminLayout.style';

interface Props {
  children: React.ReactNode;
  colorTheme?: COLOR_THEME;
}

const AdminLayout: React.FunctionComponent<Props> = ({
  children,
  colorTheme = COLOR_THEME.STAFF,
}) => {
  const [loaderOn, setLoaderOn] = useState(true);
  const [contentStateOn, setContentStateOn] = useState(false);
  const userUUid = useSelector(userUuidSelector);
  const colors = useSelector(colorsSelector);
  const FORCE_DISPLAY_DELAY_IN_MS = 2000;
  const withBamLayout = useSelector(withBamLayoutSelector);

  const displayContent = () => {
    setLoaderOn(false);
    setContentStateOn(true);
  };

  const handleAdminLayout = () => {
    if (colorTheme === COLOR_THEME.STAFF && userUUid === null) {
      return;
    }
    displayContent();
  };

  useTvToIpadMultiScreenEventsListener({
    [PlayerEvent.NOTIFY_THAT_LOGO_IS_LOADED]: () => handleAdminLayout(),
  });

  useEffect(() => {
    const forceDisplayTimeOut = setTimeout(() => {
      displayContent();
    }, FORCE_DISPLAY_DELAY_IN_MS);

    return () => clearTimeout(forceDisplayTimeOut);
  }, []);

  return (
    <>
      <LayoutContainer $on={contentStateOn} {...{ colorTheme, colors }}>
        {withBamLayout ? <AdminLogoBAM /> : <StyledTslLogo />}
        <ChildrenContainer>{children}</ChildrenContainer>
      </LayoutContainer>

      {loaderOn ? <Loader /> : null}
    </>
  );
};

export default AdminLayout;
